<template>
    <div class="interval z-1" :style="'width:'+width+'px;'">
      <div class="title" :style="'width:'+width+'px;'">
        <div class="text" :style="'margin-right:-'+width+'px;'">
          <nobr>{{ date }}</nobr>
        </div>
      </div>
      <div class="lines">
        <div class="divider"></div>
        <div class="hour"
          v-for="(offset, hour) in hours" :key="offset"
          :style="'left:'+ (offset - Math.round(minimalHourInterval / 2)) +'px;width:' + minimalHourInterval + 'px;'">
          {{ hour }}
        </div>
        <div class="hour-line"
          v-for="(offset, hour) in hours" :key="hour"
          :style="'left:'+ offset +'px;'">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['start', 'length', 'scale', 'zero', 'visibleLeft'],
  data() {
    return {
      xPadding: 20,
      minWidth: 20,
      minimalHourInterval: 50,
    }
  },
  created() {
  },
  computed: {
    date() {
      var date = new Date(this.start * 1000)
      return date.getDate() + ' ' + this.$t('month' + (date.getMonth() + 1)) 
    },
    width() {
      return Math.floor(this.length / this.scale)
    },
    hours() {
      var hours = {}
      var pixelsPerHour = 86400 / this.scale / 24
      var step = Math.ceil(this.minimalHourInterval / pixelsPerHour)
      var hour, hourDate
      for (var i = step; i < this.length / 3600; i += step) {
        hourDate = new Date()
        hourDate.setTime((this.start + i * 3600) * 1000)
        hour = '0' + hourDate.getHours()
        hour = hour.substring(hour.length - 2)
        hours[hour] = Math.round(i * pixelsPerHour)
      }
      return hours
    },
  },
  methods: {
  },
}
</script>

<i18n locale="ru" lang="yaml">
  month1: "января"
  month2: "февраля"
  month3: "марта"
  month4: "апреля"
  month5: "мая"
  month6: "июня"
  month7: "июля"
  month8: "августа"
  month9: "сентября"
  month10: "октября"
  month11: "ноября"
  month12: "декабря"
</i18n>

<i18n locale="en" lang="yaml">
  month1: "January"
  month2: "February"
  month3: "March"
  month4: "April"
  month5: "May"
  month6: "June"
  month7: "July"
  month8: "August"
  month9: "September"
  month10: "October"
  month11: "November"
  month12: "December"
</i18n>
